(function () {
  const emailRegex =
    /^(?![\.])((?:\.?[\(\)!#-'*+\-/-9=?A-Z\^-\uFFFF])*)@([!#-'*+\-/-9=?A-Z\^-\uFFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\uFFFF])*\.[!#-'*+\-/-9=?A-Z\^-\uFFFF}](?:\.?[!#-'*+\-/-9=?A-Z\^-\uFFFF])*)$/;
  const baseScriptNameRegex = /dd([a-z]+)bis/i;

  window.ddBisWidgetTemplates = {};

  window.ddBisWidgetTemplates.modalStyles =
    "<style>" +
    ".modal { position: relative; text-align: center; width: 100%; color: #000; font-size: 14px; }" +
    ".modal-heading, .success-heading, .error-heading { margin: 0; line-height: 1.2; font-size: 28px; font-weight: 400; }" +
    ".modal-content p { padding: 0 2px; }" +
    ".modal-content { padding: 30px; font-size: 14px; margin: 0 auto; display: none; word-break: break-word; }" +
    ".modal-content p:not(.footer,.error) { font-size: 14px;}" +
    ".modal-close { position: absolute; right: 16px; top: 16px; background: none; border: 0px; font-size: 14px; cursor: pointer; font-weight: bold; }" +
    ".modal-close:hover { color: #4d4d4d; }" +
    ".modal-message { display: block; }" +
    ".modal-variant-select { display: none; }" +
    ".error { color: red; text-align: left; font-size: 12px; padding: 4px 0; margin: 4px 0; display: none; }" +
    "input { width: 100%; height: 30px; padding: 16px 8px; box-sizing: border-box; border: 1px solid #ccc; background: #fff; font-size: 13px; }" +
    "select { width: 100%; margin-bottom: 16px; box-sizing: border-box; border: 1px solid #ccc; background: #fff; " +
    "overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding: 8px 8px; color: inherit; option { color: inherit; } }" +
    "input::placeholder { color: #aaa; opacity: 1; }" +
    ".footer { font-size: 12px; text-align: left; padding: 2px; }" +
    ".notify-btn, .close-btn { font-weight: 500; padding: 8px 16px; margin-top: 8px; width: 100%; cursor: pointer; border: 0; border-radius: 2px; min-height: 45px; font-size: 13px }" +
    ".close-btn { width: auto; }" +
    ".dd-spinner {" +
    "border: 16px solid #000; border-radius: 50%; border-top: 16px solid #fff; width: 100px; height: 100px; margin-top: 50px; margin-bottom: 50px;" +
    /* Safari */ "-webkit-animation: dd-spin 1.5s linear infinite; animation: dd-spin 1.5s linear infinite; display: none;" +
    "}" +
    "/* Safari */@-webkit-keyframes dd-spin { 0% { -webkit-transform: rotate(0deg); } 100% { -webkit-transform: rotate(360deg); } }" +
    "@keyframes dd-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }" +
    "</style>";

  window.ddBisWidgetTemplates.buttonStyles =
    ".dd-bis-button {" +
    "margin-top: 8px; border: none; font-weight: 500;  padding: 8px 8px; cursor: pointer; text-align: center;" +
    "}" +
    "#dd-bis-form {" +
    "box-shadow: 1px 1px 10px 2px #ddd; border: none; width: 463px; height: auto; background: #ffffff; z-index: 1000; border-radius: 4px;" +
    "}";

  window.ddBisWidgetTemplates.modalMarkup =
    '<div class="modal" id="modal-one">' +
    '<div class="modal-bg modal-exit"></div>' +
    '<div class="modal-content modal-message">' +
    '<h2 class="modal-heading">{{heading}}</h2>' +
    '<p class="modal-body">{{body}}</p>' +
    '<select class="modal-body modal-variant-select">' +
    "</select>" +
    '<p class="error field-email-validation">{{emailError}}</p>' +
    '<input type="email" class="modal-email-input field-email-watermark" placeholder="{{emailPlaceholder}}"/>' +
    '<p class="footer">{{footer}}</p>' +
    '<button class="notify-btn">{{buttonText}}</button>' +
    "</div>" +
    '<div class="modal-content modal-success-message">' +
    '<h2 class="success-heading">{{successHeading}}</h2>' +
    '<p class="success-body">{{successBody}}</p>' +
    '<button class="close-btn">{{successButtonText}}</button>' +
    "</div>" +
    '<div class="modal-content modal-error-message">' +
    '<h2 class="error-heading">{{errorHeading}}</h2>' +
    '<p class="error-body">{{errorBody}}</p>' +
    '<button class="close-btn">{{errorButtonText}}</button>' +
    "</div>" +
    '<button class="modal-close modal-exit">&#10006;</button>' +
    '<div class="dd-spinner"></div>' +
    "</div>";

  function _ddBISCallHandler() {
    _runBISSetupScript();
  }

  if (document.readyState !== "loading") {
    _ddBISCallHandler();
  } else {
    window.addEventListener ? window.addEventListener("load", _ddBISCallHandler, false) : window.attachEvent("onload", _ddBISCallHandler);
  }

  function _runBISSetupScript() {
    if (!window.dd_bis_config) {
      let asyncScripts = document.querySelectorAll("[async]");
      asyncScripts.forEach(function (v, i) {
        let originalSourceScript = v.getAttribute("src");
        if (baseScriptNameRegex.test(originalSourceScript)) {
          let configScriptUrl = _buildConfigScriptUrl(originalSourceScript),
            script = document.createElement("script");

          script.setAttribute("src", configScriptUrl);
          document.body.appendChild(script);
          script.onload = function () {
            if (Object.keys(window.dd_bis_config).length > 0) {
              _addBISLogic();
            }
          };
        }
      });
    } else {
      if (Object.keys(window.dd_bis_config).length > 0) {
        _addBISLogic();
      }
    }
  }

  function _buildConfigScriptUrl(src) {
    return src.replace(baseScriptNameRegex, "ddbis-config");
  }

  function _addBISLogic() {
    const isBISEnabled = window.dd_bis_config.enabled;
    if (!isBISEnabled) return;

    let node = _getNodeToInsertButtonAfter();
    if (!node) return;

    let isProductPage = _isProductPage();
    if (isProductPage) {
      _getProductData().then(function (productData) {
        _addWidgetAndAddVariantChangeListener(productData);
      });
    }
  }

  function _addWidgetAndAddVariantChangeListener(productData) {
    let productTags = _getProductTags(productData);
    let enableBIS = _isProductEnabledForBackInStock(productTags);

    if (enableBIS) {
      _createButtonAndBISForm(productData);
      _detectProductVariantChange(productData);
    }
  }

  function _detectProductVariantChange(productData) {
    document.addEventListener("change", function (e) {
      let productForms = _getProductFormElements();

      if (!productForms.length) return;

      /* This condition ensures that the element raising the event is within the product form */
      if (e.target !== productForms[0] && _productFormContainsItemClicked(e.target)) {
        let variantId = _getVariantId(productData);
        let isVariantAvailable = _getProductOrVariantAvailability(productData, variantId);
        _createBISButton(isVariantAvailable);
        _setDataProductFieldsOnBISForm(productData, variantId);
      }
    });
  }

  function _createButtonAndBISForm(productData) {
    let variantId = _getVariantId(productData);
    let isVariantAvailable = _getProductOrVariantAvailability(productData, variantId);
    _createBISButton(isVariantAvailable);
    _addBISForm(productData, variantId);
    _addEventListenersToForm();
    _closeFormOnPageClick();
  }

  function _isProductEnabledForBackInStock(productTags) {
    let configTags = dd_bis_config.tags;
    if (!configTags || (!configTags?.include?.length && !configTags.exclude?.length)) return true;

    let matchesIncluded = _utils._intersectTags(productTags, configTags.include);
    let matchesExcluded = _utils._intersectTags(productTags, configTags.exclude);

    if (configTags.include?.length) {
      if (matchesIncluded) return !matchesExcluded;
      return false;
    }
    return !matchesExcluded;
  }

  function _createBISButton(isVariantAvailable) {
    let button = document.querySelector("#dd-notify-me-button");

    if (!isVariantAvailable && button === null) {
      let newButton = document.createElement("button");

      newButton.innerHTML = dd_bis_config.widgetSettings.content.notifyButton;
      newButton.setAttribute("id", "dd-notify-me-button");
      newButton.classList.add("dd-bis-button");
      newButton.setAttribute("type", "button");
      _appendButtonToProductForm(newButton);
    }
    _showOrHideButton(isVariantAvailable);
  }

  function _appendButtonToProductForm(newButton) {
    let node = _getNodeToInsertButtonAfter();
    node.parentNode.insertBefore(newButton, node.nextSibling);

    _addClickHandlerToBISButton();
    _addButtonStyles();
  }

  function _addButtonStyles() {
    let styles = _addStaticButtonStyles();
    styles += _addAutoGeneratedStyles();
    styles += _addStyleOverrides();

    let style = document.createElement("style");
    style.innerHTML = styles;
    style.setAttribute("id", "button-styles");

    let ref = document.querySelector("script");
    ref.parentNode.insertBefore(style, ref);
  }

  function _addStaticButtonStyles() {
    return window.ddBisWidgetTemplates.buttonStyles;
  }

  function _addAutoGeneratedStyles() {
    let widthAndHeight = _getButtonWidthAndHeight(),
      buttonFontSize = _getButtonFontSize();

    return ".dd-bis-button {" + "width: " + widthAndHeight.width + ";" + "min-height: " + widthAndHeight.height + ";" + "font-size: " + buttonFontSize + ";" + "}";
  }

  function _addStyleOverrides() {
    let buttonStyles = _getUserConfigButtonStyles();
    return ".dd-bis-button { " + buttonStyles + " }" + ".dd-bis-button:hover { box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2); }";
  }

  function _getUserConfigButtonStyles() {
    return _styleToString(window.dd_bis_config.widgetSettings.styles.notifyButton);
  }

  function _styleToString(style) {
    return Object.keys(style).reduce(function (acc, key) {
      return (
        acc +
        key
          .split(/(?=[A-Z])/)
          .join("-")
          .toLowerCase() +
        ":" +
        style[key] +
        ";"
      );
    }, "");
  }

  function _showOrHideButton(isVariantAvailable) {
    let button = document.querySelector("#dd-notify-me-button");
    if (button !== null) {
      button.style.display = isVariantAvailable ? "none" : "block";
    }
  }

  function _addClickHandlerToBISButton() {
    document.addEventListener("click", function (e) {
      if (e.target && e.target.id == "dd-notify-me-button") {
        e.preventDefault();
        _positionBISForm(e);
        let shadowRoot = document.querySelector("#dd-bis-form").shadowRoot;
        shadowRoot = _utils._replacePlaceholderText(shadowRoot);
        shadowRoot.querySelector(".modal-success-message").style.display = "none";
        shadowRoot.querySelector(".modal-error-message").style.display = "none";
        shadowRoot.querySelector(".error").style.display = "none";
        shadowRoot.querySelector(".modal-message").style.display = "block";
        shadowRoot.querySelector(".modal-email-input").focus();
      }
    });
  }

  function _addBISForm(productData, variantId) {
    let bisForm = document.querySelector("#dd-bis-form"),
      BISConfigSettings = dd_bis_config.widgetSettings;

    if (bisForm === null) _buildBISForm(BISConfigSettings);

    _setDataProductFieldsOnBISForm(productData, variantId);
  }

  function _setDataProductFieldsOnBISForm(productData, variantId) {
    let modal = document.querySelector("#dd-bis-form").shadowRoot.querySelector(".modal"),
      productDataParam = _getProductDataForModal(productData, variantId);
    // 20240806 選択した variant にズレが生じているためタイミングを調整
    setTimeout(function () {
      _patchSelectWithVariantsData(productData);
    }, 100);

    modal.setAttribute("data-product", JSON.stringify(productDataParam));
  }

  function _patchSelectWithVariantsData(productData) {
    let shadowRoot = document.querySelector("#dd-bis-form").shadowRoot,
      selector = shadowRoot.querySelector(".modal-variant-select");
    selector.style.display = "none";
  }

  function _buildBISForm(BISConfigSettings) {
    let html = getBISFormStyles();
    html += getBISFormHTML(BISConfigSettings);

    let bisForm = document.createElement("div");
    bisForm.setAttribute("id", "dd-bis-form");
    bisForm.style.display = "none";
    bisForm.attachShadow({ mode: "open" }).innerHTML = html;

    document.body.appendChild(bisForm);
  }

  function getBISFormStyles() {
    let styles = _addStaticFormStyles();
    styles += _addAutoGeneratedFormStyles();
    styles += _addFormStyleOverrides();

    return styles;
  }

  function _addStaticFormStyles() {
    return window.ddBisWidgetTemplates.modalStyles;
  }

  function _addFormStyleOverrides() {
    let modalConfig = window.dd_bis_config.widgetSettings,
      buttonStyles = _styleToString(modalConfig.styles.modalButton),
      headingStyles = _styleToString(modalConfig.styles.modalHeading),
      bodyStyles = _styleToString(modalConfig.styles.modalBody);

    return (
      "<style>" +
      ".modal { " +
      bodyStyles +
      " }" +
      ".modal-heading, .success-heading, .error-heading { " +
      headingStyles +
      " }" +
      ".notify-btn, .close-btn { " +
      buttonStyles +
      " }" +
      ".field-email-watermark {" +
      bodyStyles +
      "}" +
      ".field-email-watermark { color: #2E2E2E; }" +
      "</style>"
    );
  }

  function getBISFormHTML(modalOptions) {
    let modalHtmlContent = window.ddBisWidgetTemplates.modalMarkup,
      modalOptionsContent = modalOptions.content;

    modalHtmlContent = _replaceWithConfigText(modalHtmlContent, modalOptionsContent);
    modalHtmlContent = _utils._wrapPlaceholders(modalHtmlContent);

    return modalHtmlContent;
  }

  function _replaceWithConfigText(modalHtmlContent, modalOptionsContent) {
    let modalBodyContent = _utils._replaceLineReturnsWithBrs(modalOptionsContent.modalBody),
      successBodyContent = _utils._replaceLineReturnsWithBrs(modalOptionsContent.successBody);

    return modalHtmlContent
      .replace("{{heading}}", modalOptionsContent.modalHeading)
      .replace("{{body}}", modalBodyContent)
      .replace("{{buttonText}}", modalOptionsContent.modalButton)
      .replace("{{footer}}", "")
      .replace("{{emailPlaceholder}}", modalOptionsContent.fieldEmailWatermark)
      .replace("{{emailError}}", modalOptionsContent.fieldEmailValidation)
      .replace("{{successHeading}}", modalOptionsContent.successHeading)
      .replace("{{successBody}}", successBodyContent)
      .replace("{{successButtonText}}", modalOptionsContent.closeButton)
      .replace("{{errorHeading}}", modalOptionsContent.errorHeading)
      .replace("{{errorBody}}", modalOptionsContent.errorBody)
      .replace("{{errorButtonText}}", modalOptionsContent.closeButton);
  }

  function _positionBISForm(e) {
    let bisForm = document.querySelector("#dd-bis-form");
    let bisButton = document.getElementById("dd-notify-me-button");
    bisButton.parentNode.insertBefore(bisForm, bisButton);

    bisForm.style.position = "absolute";
    bisForm.style.display = "block";

    _repositionFormOnOverlap(bisForm, bisButton);
    _repositionBISFormForMobile(bisForm);
  }

  function _repositionFormOnOverlap(bisForm, bisButton) {
    bisForm.style.top = "";
    bisForm.style.left = "";

    let buttonPosition = bisButton.getBoundingClientRect(),
      bisFormBottom = buttonPosition.top + bisForm.clientHeight,
      bisFormRight = bisForm.getBoundingClientRect().right;

    if (bisFormBottom > window.innerHeight) {
      const newTopPosition = bisButton.offsetTop - bisForm.clientHeight;
      bisForm.style.top = newTopPosition + "px";
    }

    if (bisFormRight > window.innerWidth) {
      const bisFormStyles = window.getComputedStyle(bisForm);
      const newLeftPosition = parseInt(bisFormStyles.left) + (window.innerWidth - bisFormRight);

      bisForm.style.left = newLeftPosition + "px";
    }
  }

  function _repositionBISFormForMobile(bisForm) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      bisForm.style.left = "0px";
      bisForm.style.width = "100%";
    }
  }

  function _addEventListenersToForm() {
    let shadowRoot = document.querySelector("#dd-bis-form").shadowRoot;
    shadowRoot.querySelector(".modal-close").addEventListener("click", function () {
      _closeBISForm();
    });
    shadowRoot.querySelectorAll(".close-btn").forEach(function (item) {
      item.addEventListener("click", function (event) {
        _closeBISForm();
      });
    });

    _addClickHandlersToFormSubmit(shadowRoot);
  }

  function _addClickHandlersToFormSubmit(shadowRoot) {
    shadowRoot.querySelector(".modal-email-input").addEventListener(
      "keydown",
      function (e) {
        if (e.keyCode == 13) {
          _validateAndSubmitForm();
        }

        e.stopPropagation();
      },
      true
    );

    shadowRoot.querySelector(".notify-btn").addEventListener("click", function () {
      _validateAndSubmitForm();
    });
  }

  function _validateAndSubmitForm() {
    let shadowRoot = document.querySelector("#dd-bis-form").shadowRoot,
      emailInput = shadowRoot.querySelector(".modal-email-input").value,
      select = shadowRoot.querySelector(".modal-variant-select"),
      data = JSON.parse(shadowRoot.querySelector(".modal").getAttribute("data-product"));

    let variantId = select.style.display === "none" ? data.variantId : select.value;

    let submitData = {
      productId: data.id,
      variantId: variantId,
      ddID: dd_bis_config.ddID,
      email: emailInput,
      notificationSettingsID: dd_bis_config.notificationSettingsID,
    };

    let emailIsValid = _validateEmail(emailInput);
    if (!emailIsValid) {
      shadowRoot.querySelector(".error").style.display = "block";
      return false;
    }
    _submitForm(shadowRoot, submitData);
  }

  function _validateEmail(emailInput) {
    if (!emailInput || emailInput.match(emailRegex) === null) {
      return false;
    }
    return true;
  }

  function _submitForm(shadowRoot, params) {
    let xhttp = new XMLHttpRequest();

    xhttp.open("POST", "https://r3-t.trackedlink.net/product-notifications", true);
    xhttp.setRequestHeader("content-type", "application/json");
    xhttp.send(JSON.stringify(params));
    shadowRoot.querySelector(".modal-message").style.display = "none";
    shadowRoot.querySelector(".dd-spinner").style.display = "inline-block";

    xhttp.onload = function () {
      shadowRoot.querySelector(".dd-spinner").style.display = "none";
      if (xhttp.status >= 200 && xhttp.status < 300) {
        shadowRoot.querySelector(".error").style.display = "none";
        shadowRoot.querySelector(".modal-message").style.display = "none";
        shadowRoot.querySelector(".modal-success-message").style.display = "block";
        shadowRoot.querySelector(".modal-email-input").value = "";
      } else if (xhttp.status >= 400 && xhttp.status <= 599) {
        shadowRoot.querySelector(".modal-error-message").style.display = "block";
        console.error(xhttp.responseText);
      } else {
        shadowRoot.querySelector(".modal-email-input").value = "";
        shadowRoot.querySelector(".modal-message").style.display = "block";
      }
    };
  }

  function _closeBISForm() {
    let form = document.querySelector("#dd-bis-form");
    form.style.display = "none";
  }

  function _closeFormOnPageClick() {
    document.addEventListener("click", function (e) {
      let bisForm = document.querySelector("#dd-bis-form"),
        isOutOfStockButton = e.target.id === "dd-notify-me-button";
      const eventPath = e.composedPath && e.composedPath();
      const isBisFormInEventPath = eventPath && eventPath.includes(bisForm);

      if (!isBisFormInEventPath && !isOutOfStockButton) {
        bisForm.style.display = "none";
      }
    });
  }

  function getConfiguredRefNode() {
    return document.querySelector(window.dd_bis_config.refNode);
  }

  _utils = {
    _intersectTags: function (productTags, configTags) {
      if (!productTags?.length || !configTags?.length) return false;
      configTags = configTags.map(function (originalTag) {
        return originalTag.toLowerCase();
      });
      return productTags.some(function (productTag) {
        return configTags.includes(productTag.toLowerCase());
      });
    },
    _wrapPlaceholders: function (modalHTML) {
      let placeHolderMatcher = /\@(([A-Z]+)\_([A-Z]+))\@/gim;
      let match;
      while ((match = placeHolderMatcher.exec(modalHTML)) != null) {
        let placeholder = _utils._convertPlaceholderToClassName(match[1]);
        modalHTML = modalHTML.replace(match[0], '<span class="placeholder" data-placeholder="' + placeholder + '"></span>');
      }
      return modalHTML;
    },
    _convertPlaceholderToClassName: function (text) {
      return text.replace(/\_/, "-").toLowerCase();
    },
    _replacePlaceholderText: function (shadowRoot) {
      let data = JSON.parse(shadowRoot.querySelector(".modal").getAttribute("data-product"));
      shadowRoot.querySelectorAll(".placeholder").forEach(function (v) {
        let key = v.getAttribute("data-placeholder");
        if (key === "variant-title") {
          v.innerText = data.variantTitle || "";
        } else if (key === "product-title") {
          v.innerText = data.title || "";
        }
      });
      return shadowRoot;
    },
    _replaceLineReturnsWithBrs: function (content) {
      return content.replace(/\n/gim, "<br />");
    },
  };

  // --- FUNCTIONS USED IN BASE SCRIPT ---

  function _getVariantId(productData) {
    let variantId = _getVariantFromUrl(window.location.href);
    return variantId ?? getDefaultVariantIdWhenNoVariantsAvailable(productData);
  }

  function _getProductOrVariantAvailability(productData, variantId) {
    let variantSelectorEnabled = window.dd_bis_config.variantSelectorEnabled;

    if (variantId && !variantSelectorEnabled) {
      return productData.variants.filter(function (variant) {
        return variant.id === parseInt(variantId);
      })[0].available;
    }

    if (variantSelectorEnabled) {
      return !productData.variants.some((variant) => !variant.available);
    }

    return productData.variants.some(function (variant) {
      return variant.available;
    });
  }

  function _getProductTags(productData) {
    return productData.tags;
  }

  function _getProductData() {
    let productHandle = _getProductHandleFromUrl();
    if (productHandle) {
      return fetch("/products/" + productHandle + ".js")
        .then(function (response) {
          return response.json();
        })
        .then(function (productData) {
          return productData;
        });
    }
    throw "Failed to get product data.";
  }

  function _getProductDataForModal(productData, variantId) {
    let variantData = productData.variants.filter(function (variant) {
      return variant.id === parseInt(variantId);
    })[0];

    let basicProductData = {
      id: productData.id.toString(),
      title: productData.title,
    };

    if (variantData) {
      basicProductData.variantId = variantId;
      basicProductData.variantTitle = variantData.title;
    }

    return basicProductData;
  }

  function _isProductPage() {
    return window.meta.page.pageType === "product";
  }

  function _getProductFormElements() {
    return document.querySelectorAll('[action$="\\/cart\\/add"]');
  }

  function _getNodeToInsertButtonAfter() {
    return getConfiguredRefNode() || getButtonWithDataShopifyAttr() || getDefaultStoreNode();
  }

  function _getButtonWidthAndHeight() {
    let positionNode = _getNodeToInsertButtonAfter(),
      styleNode = getConfiguredRefNode() || getDefaultStoreNode();

    if (styleNode === null) return { height: "auto", width: "auto" };

    let computedButtonStyles = window.getComputedStyle(styleNode),
      formattedHeight = !isNaN(parseInt(computedButtonStyles.height)) ? computedButtonStyles.height : "auto",
      formattedWidth = !isNaN(parseInt(computedButtonStyles.width)) ? _getPercWidth(positionNode, computedButtonStyles) + "%" : "auto";

    return { height: formattedHeight, width: formattedWidth };
  }

  function _getButtonFontSize() {
    let refNode = _getNodeToInsertButtonAfter();
    return window.getComputedStyle(refNode).fontSize;
  }

  function _addAutoGeneratedFormStyles() {
    return "<style>" + ".notify-btn:hover, .close-btn:hover { box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);}" + "</style>";
  }

  // --- OVERRIDES ---

  function _patchSelectWithVariantsData(productData) {
    const shadowRoot = document.querySelector("#dd-bis-form").shadowRoot,
      selector = shadowRoot.querySelector(".modal-variant-select");
    selector.style.display = "none";

    if (!window.dd_bis_config.variantSelectorEnabled) {
      return;
    }

    if (productData.variants.length <= 1) {
      selector.style.display = "none";
      return;
    }

    selector.style.display = "block";
    selector.length = 0;
    let selectedVariantId = _getVariantId(productData);

    for (let i = 0; i < productData.variants.length; ++i) {
      let variant = productData.variants[i];
      if (variant.available) {
        continue;
      }
      selector[selector.length] = new Option(variant.title, variant.id);

      if (variant.id == selectedVariantId) {
        selector.selectedIndex = selector.length - 1;
      }
    }
  }

  function _productFormContainsItemClicked(itemClicked) {
    const productFormElements = _getProductFormElements();
    if (productFormElements.length > 1) {
      return itemClicked.closest('[action$="\\/cart\\/add"]') !== null;
    }
    return productFormElements.length > 0 ? productFormElements[0].contains(itemClicked) : false;
  }

  // --- PRIVATE FUNCTIONS ---

  function _getProductHandleFromUrl() {
    let urlMatcher = _getUrlParts(window.location.href);
    return urlMatcher && urlMatcher.groups && urlMatcher.groups.productHandle ? urlMatcher.groups.productHandle : null;
  }

  function _getUrlParts(url) {
    let productIdentifierRegex = /(?!products).*\/(?<productHandle>([^#?]+))(\?variant=(?<variantId>([0-9]+)))?/;
    return url.match(productIdentifierRegex);
  }

  function _getVariantFromUrl(url) {
    let variantIdentifierRegex = /[?&]variant=(?<variantId>([^&]\d+))/;
    return url.match(variantIdentifierRegex)?.groups?.variantId;
  }

  function _getPercWidth(node, buttonStyles) {
    let parentWidth = window.getComputedStyle(node.parentNode).width,
      parentPadding = window.getComputedStyle(node.parentNode).paddingLeft;
    return (parseInt(buttonStyles.width) / (parseInt(parentWidth) - parseInt(parentPadding) * 2)) * 100;
  }

  function _getFontSize() {
    return getComputedStyle(document.querySelector("body")).fontSize;
  }

  function getButtonWithDataShopifyAttr() {
    return document.querySelector('[data-shopify="payment-button"]');
  }

  function getDefaultStoreNode() {
    let backupNode = ".product-form__submit,.product-form__cart-submit,.btn--add-to-cart,.product__add-to-cart-button,.product-single__cart-submit,.product-form__add-button";
    return document.querySelector(backupNode);
  }

  function getDefaultVariantIdWhenNoVariantsAvailable(productData) {
    let inStockVariants = productData.variants.filter(function (variant) {
      return variant.available;
    });
    return inStockVariants.length === 0 ? productData.variants[0].id.toString() : null;
  }
})();
